// URL ↔ state for the /documents library's source filter (#165). Mirrors the
// `document_source` schema enum plus a synthetic `all` sentinel (the default,
// omitted from the URL). The literal union is duplicated from the schema here
// to keep ui-url-state framework- and schema-free (no db-types import); the
// document-row helper that consumes it is structurally compatible.

export type DocumentsSourceFilter =
  | 'all'
  | 'manual_upload'
  | 'revolut_api'
  | 'email_inbox'
  | 'eigenbeleg';

const VALID_SOURCES: ReadonlySet<DocumentsSourceFilter> = new Set([
  'all',
  'manual_upload',
  'revolut_api',
  'email_inbox',
  'eigenbeleg',
]);

export function parseDocumentsSource(input: unknown): DocumentsSourceFilter {
  if (typeof input !== 'string') return 'all';
  return VALID_SOURCES.has(input as DocumentsSourceFilter)
    ? (input as DocumentsSourceFilter)
    : 'all';
}

export function documentsSourceToSearch(source: DocumentsSourceFilter): {
  source?: DocumentsSourceFilter;
} {
  return source === 'all' ? {} : { source };
}
